import * as React from 'react';

import { IconWarning } from '@lightspeed/flame/Icon/Warning';
import { TextLink } from '@lightspeed/flame/Text';

import { StyledAlert } from './DeprecationNotice.style';

interface DeprecationNoticeProps {
  content?: string;
  learnMoreLink?: string;
  callback?: () => void;
}

export const DeprecationNotice: React.FC<DeprecationNoticeProps> = ({
  content,
  learnMoreLink,
  callback,
}) => {
  return (
    <StyledAlert
      className="cr-mb-4"
      icon={<IconWarning size="1rem" baseColor="orange-500" detailsColor="orange-100" />}
      noCloseBtn
      type="warning"
    >
      {content ||
        'The Zebra Browser Print app will be replaced with Lightspeed Hub for all your printing needs. To continue using your Zebra label printer, install Lightspeed Hub.'}{' '}
      &nbsp;
      <TextLink
        onClick={() => {
          window.PageRouter.goTo(learnMoreLink || '/devices');
          if (callback) callback();
        }}
      >
        Learn more
      </TextLink>
    </StyledAlert>
  );
};
